import {Component, Input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-locator-marker',
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './locator-marker.component.html',
  styleUrl: './locator-marker.component.css'
})
export class LocatorMarkerComponent {
  @Input() icon?: string
}
